import { PermissionGroup } from "./permission-group";

export class User {
  id: string = "";
  username: string = "";
  password: string = "";
  email: string = "";
  firstName: string = "";
  lastName: string = "";
  phone: string = "";
  userGroups?: PermissionGroup[];
  userGroupIds: any;
  role?: string;
  enabled?: boolean;
  gender?: string;//Todo with enum
  branchId?: string = "";
  branchCode: string = "";
  cashDeskId?: string;
  locked?: boolean;
}
